const BASE = process.env.REACT_APP_BACKEND_URL;

async function j(res) {
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export const kbApi = {
  bootstrap: () => fetch(`${BASE}/api/kb/bootstrap`).then(j),
  footprint: (id) => fetch(`${BASE}/api/kb/footprint/${id}`).then(j),
  opportunity: (payload) => fetch(`${BASE}/api/kb/opportunity`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) }).then(j),
  override: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return fetch(`${BASE}/api/kb/override`, { method: "POST", body: fd }).then(j);
  },
};
